<style lang="scss" scoped>
</style>
<template>
  <div>
    <tj-title-bar :title="healthcheckBookTeam.teamName" :content="rangeText">
      <p slot="right">
        <span class="fs14">{{ currYear }}</span>
      </p>
    </tj-title-bar>
    <div class="mainbox mt15 bg_fff">
      <section class="pl15 pr15 pt10 pb10 flex aic">
        <p class="fs14 flex1">
          已预约人数：<span class="color_green">{{ total.waitCheckCount }}</span>人
          未预约人数：<span class="color_red">{{ total.waitHandleCount }}</span>人
          已到检人数：<span class="color_main">{{ total.alredayCheckCount }}</span>人
        </p>
      </section>
      <el-table :data="list" border size="mini">
        <el-table-column label="日期" prop="healthcheckCountDate"></el-table-column>
        <el-table-column label="已预约人数" prop="waitCheckCount"></el-table-column>
        <el-table-column label="剩余可预约号源" prop="surplusNumberSourceTotal"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="detail(row,'detail')">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import TjTitleBar from "../components/tj-title-bar";
import {healthcheckService} from "../services/healthcheck";
import {riliItemCacheKey} from "../config";

export default {
  name: 'tj-statistics',
  components: {TjTitleBar},
  data() {
    return {
      curr: new Date(),
      total: {},
      list: []
    }
  },
  computed: {
    currYear() {
      const {curr} = this;
      return dayjs(curr).year();
    },
    first() {
      const {curr} = this;
      return dayjs(curr).startOf('month')
    },
    last() {
      const {curr} = this;
      return dayjs(curr).endOf('month');
    },
    rangeText() {
      const {startDate, endDate} = this.healthcheckBookTeam;
      const format = 'YYYY-MM-DD';
      return `预约日期范围：${dayjs(startDate).format(format)}~${dayjs(endDate).format(format)}`;
    },
  },
  created() {
    this.getCount();
  },
  methods: {
    detail(data, type = 'list') {
      this.$cache.set(riliItemCacheKey, data);
      const date = data.healthcheckCountDate.replace(/\//g, '-')
      if (type === 'list') this.$router.push({
        path: '/tj/list',
        query: {
          date
        }
      })
      else this.$router.push({
        path: '/tj/detail',
        query: {
          date
        }
      })
    },
    async getCount() {
      const teamId = this.healthcheckBookTeam.id;
      this.total = await healthcheckService.tjCount(teamId);
      this.list = await healthcheckService.tjOrderDateList(teamId);
    }
  },
}
</script>
